import React from 'react';
import PropTypes from 'prop-types';
import { Button } from './Button';
import './ui.css';

/** Nothing to show (e.g. no rows match the filters). */
export function EmptyState({ icon, title, message, action }) {
    return (
        <div className="v2-state v2-state--empty">
            {icon && <div className="v2-state-ic" aria-hidden="true">{icon}</div>}
            {title && <h3>{title}</h3>}
            {message && <p>{message}</p>}
            {action}
        </div>
    );
}

EmptyState.propTypes = { icon: PropTypes.node, title: PropTypes.node, message: PropTypes.node, action: PropTypes.node };

/** A failed load, announced; Retry when the caller can retry. Today's wording by default. */
export function ErrorState({ title = 'Something went wrong', message, onRetry, retryLabel = 'Retry' }) {
    return (
        <div className="v2-state v2-state--error" role="alert">
            <div className="v2-state-ic v2-state-ic--error" aria-hidden="true">!</div>
            <h3>{title}</h3>
            {message && <p>{message}</p>}
            {onRetry && <Button variant="primary" onClick={onRetry}>{retryLabel}</Button>}
        </div>
    );
}

ErrorState.propTypes = {
    title: PropTypes.node,
    message: PropTypes.node,
    onRetry: PropTypes.func,
    retryLabel: PropTypes.node,
};

/** Spinner with a visible label, announced politely. */
export function LoadingState({ label = 'Loading…' }) {
    return (
        <div className="v2-state v2-state--loading" role="status">
            <span className="v2-spinner" aria-hidden="true" />
            <p>{label}</p>
        </div>
    );
}

LoadingState.propTypes = { label: PropTypes.node };

/** Shimmering placeholder lines; decorative. */
export function Skeleton({ lines = 3, widths }) {
    return (
        <div className="v2-skel" aria-hidden="true">
            {Array.from({ length: lines }, (_, i) => (
                <span
                    key={i}
                    className="v2-sk"
                    style={{ width: widths?.[i] || (i === lines - 1 && lines > 1 ? '60%' : '100%') }}
                />
            ))}
        </div>
    );
}

Skeleton.propTypes = { lines: PropTypes.number, widths: PropTypes.arrayOf(PropTypes.string) };
